import { z } from "zod";
import { BaseDrawer, BaseDrawerState, CreateBaseDrawerHook } from "../base_drawer";
import { FormPercentageMaskedInput } from "../../masked_inputs/react_forms/form_percentage_masked_input";
import { FormRadioGroupInput } from "../../masked_inputs/react_forms/form_radio_group_input";

import DefaultFormInput from "../../default_form_input";

/**
 * Schema
 */

const CentroCustoSchema = z.object({
  status: z.coerce.number(),
  codigo: z.string().nonempty({ message: "É necessário preencher este campo!" }),
  descricao: z.string().nonempty({ message: "É necessário preencher este campo!" }),
  bdi: z.coerce.number().nullable().optional(),
  bdi2: z.coerce.number().nullable().optional(),
  numeroCno: z.string().nullable().optional(),
  obsCentroCusto: z.string().nullable().optional()
});

type CentroCustoForm = z.infer<typeof CentroCustoSchema>;

/**
 * useCentroCustoDrawer
 * [centroCustoStateDrawer, startCentroCustoDrawer]
 */

export const useCentroCustoDrawer = CreateBaseDrawerHook<CentroCustoForm>();

/**
 * CentroCustoDrawer
 */

type Props = {
  state: BaseDrawerState<CentroCustoForm>;
  saving: boolean;
};

export const CentroCustoDrawer = ({
  state,
  saving,
}: Props) => {
  return (
    <BaseDrawer
      title="Novo Centro Custo"
      saving={saving}
      state={state}
      schema={CentroCustoSchema}>
      {
        (hookForm) => (
          <>
            <FormRadioGroupInput
              name='status'
              label='Status'
              options={[
                { id: 0, label: 'Ativo' },
                { id: 1, label: 'Bloqueado' },
                { id: 2, label: 'Encerrado' },
              ]}
              readOnly={saving}
              reactHookForm={hookForm} />

            <DefaultFormInput
              name='codigo'
              label='Código'
              required={true}
              readOnly={saving}
              reactHookForm={hookForm} />

            <DefaultFormInput
              name='descricao'
              label='Nome de Centro de Custo'
              required={true}
              readOnly={saving}
              reactHookForm={hookForm}
            />

            <FormPercentageMaskedInput
              name='bdi'
              label='BDI'
              required={false}
              readOnly={saving}
              reactHookForm={hookForm}
            />

            <FormPercentageMaskedInput
              name='bdi2'
              label='BDI 02'
              required={false}
              readOnly={saving}
              reactHookForm={hookForm}
            />

            <DefaultFormInput
              name='numeroCno'
              label='N° CNO'
              required={false}
              readOnly={saving}
              reactHookForm={hookForm}
            />
          </>
        )
      }
    </BaseDrawer>
  );
}